module.exports = __webpack_public_path__ + "VIPG5.png?47881bb759b6c5c8f5829fb80492aa91";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/greyhounds/VIPG5.png
// module id = 77
// module chunks = 0